import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo from '../assets/images/logoforpdf.jpeg';
import CryptoJS from 'crypto-js';

export const getStorage = (key) => {
	try {
		const serializeState = localStorage.getItem(key);
		if (serializeState === null) {
			return undefined;
		}
		return JSON.parse(serializeState);
	} catch (error) {
		console.error('Err: Set Local Storage :', error);
	}
};

export const setStorage = (key, state) => {
	try {
		const serializeState = JSON.stringify(state);
		localStorage.setItem(key, serializeState);
	} catch (error) {
		console.error('Err: Get Local Storage:', error);
	}
};

export function getUser() {
	const userProfile = getStorage('userProfile');
	return userProfile;
}

export function hasProperty(obj, key) {
	return Object.prototype.hasOwnProperty.call(obj, key);
}

export function isEmpty(obj) {
	let isEmpty = false;
	const type = typeof obj;
	isEmpty = isEmpty || !obj;
	isEmpty = isEmpty || type === 'undefined'; // if it is undefined
	isEmpty = isEmpty || obj === null; // if it is null
	isEmpty = isEmpty || (type === 'string' && obj.trim() === ''); // if the string is empty or only have spaces
	isEmpty = isEmpty || obj === false || obj === 0; // if boolean value returns false
	isEmpty = isEmpty || (Array.isArray(obj) && obj.length === 0); // if array is empty
	isEmpty = isEmpty || (type === 'object' && Object.keys(obj).length === 0); // if object is empty
	return isEmpty;
}

export const getSelectOptions = (objList, id = 'id', name = 'name') => {
	const options = [];
	if (isEmpty(objList)) {
		return options;
	}
	if (Array.isArray(objList)) {
		objList.forEach((obj) => {
			const optValue = obj[id];
			const optName = obj[name];
			options.push({ label: optName, value: optValue });
		});
	} else {
		Object.keys(objList).forEach((key) => {
			const optValue = objList[key][id] || key;
			const optName = objList[key][name] || objList[key];
			options.push({ label: optName, value: optValue });
		});
	}

	return options;
};

// const number = /^[0-9]+$/;
// const name = /^[A-Za-z\s]+$/i;

export const userLogout = () => {};

export const removeMsg = (setMsg) => {
	setTimeout(() => {
		setMsg('');
	}, 3000);
};

export const numberToWords = (number) => {
	try {
		if (!isEmpty(number)) {
		const numArr = number?.toString()?.split('.');

		const intNumber = numArr[0];
		let flotNum = numArr[1];

		if (flotNum?.length === 1 && flotNum > 0) {
			flotNum = flotNum * 10;
		}
		// Array of words for numbers from 0 to 19
		const words = [
			'Zero',
			'One',
			'Two',
			'Three',
			'Four',
			'Five',
			'Six',
			'Seven',
			'Eight',
			'Nine',
			'Ten',
			'Eleven',
			'Twelve',
			'Thirteen',
			'Fourteen',
			'Fifteen',
			'Sixteen',
			'Seventeen',
			'Eighteen',
			'Nineteen',
		];

		// Array of tens words
		const tensWords = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

		// Handle numbers from 0 to 99
		const convertToWords = (num) => {
			if (num < 20) {
				return words[parseInt(num)];
			} else {
				const tens = Math.floor(num / 10);
				const units = num % 10;

				if (units === 0) {
					return tensWords[tens];
				} else {
					return tensWords[tens] + ' ' + words[Math.floor(units)];
				}
			}
		};

		// Handle numbers above 99
		const convertNumber = (num) => {
			if (num === 0) {
				return 'Zero';
			}
			let words = '';
			if (num >= 10000000) {
				words += convertNumber(Math.floor(num / 10000000)) + ' Crore ';
				num %= 10000000;
			}
			if (num >= 100000) {
				words += convertNumber(Math.floor(num / 100000)) + ' Lakh ';
				num %= 100000;
			}
			if (num >= 1000) {
				words += convertNumber(Math.floor(num / 1000)) + ' Thousand ';
				num %= 1000;
			}
			if (num >= 100) {
				words += convertToWords(Math.floor(num / 100)) + ' Hundred ';
				num %= 100;
			}
			if (num > 0) {
				words += convertToWords(num);
			}
			return words.trim();
		};

		if (flotNum > 0) {
			return convertNumber(intNumber) + ' Rupees And ' + convertNumber(flotNum) + ' Paise Only';
		} else {
			return convertNumber(intNumber) + ' Rupees Only';
		}
	}
	} catch (error) {
		return "";
	}
	
};

export const overLayers = (key,size="all") => {
	var body = document.getElementsByTagName('body');
	if(size !=="all" ){
		if((window.innerWidth >= 768)) return;
	}
	if (!isEmpty(key)) {
		body[0].style.overflowY = 'hidden';
	} else {
		body[0].style.overflowY = 'auto';
	}
};

export const isValidMobileNumber = (number) => {
	const regex = /^[0-9]{10}$/;
	return regex.test(number);
};

export const downloadDivAsImage = (element, title = 'downloaded_image', setCustonCss = () => {}, value = {}) => {
	const buttons = element?.querySelectorAll('button');
	const close = element?.querySelector('.modal-close');
	
	const originalVisibilities = [];
	try {
	buttons.forEach((button) => {
		originalVisibilities.push(button.style.visibility); 
		button.style.visibility = 'hidden'; 
	  });
	  close.style.display = 'none';
	} catch (error) {
		
	}
	html2canvas(element).then((canvas) => {

		const dataUrl = canvas.toDataURL('image/png');
		saveAs(dataUrl, `${title}.png`);
		try {
			buttons.forEach((button, index) => {
				button.style.visibility = originalVisibilities[index];
			  });
			  close.style.display = 'block';
		} catch (error) {
			
		}
		setCustonCss({ ...value });
		return;
	});
};

export function getCurrentDate(formate = '', date = '', time = false) {
	var date;
	if (date === '') {
		date = new Date();
	} else {
		date = new Date(date);
	}

	var day = date.getDate();
	var month = date.getMonth() + 1;
	var year = date.getFullYear();
	var hours, minutes, seconds;
	if (time) {
		hours = String(date.getHours()).padStart(2, '0');
		minutes = String(date.getMinutes()).padStart(2, '0');
		seconds = String(date.getSeconds()).padStart(2, '0');
	}

	if (day < 10) {
		day = '0' + day;
	}

	if (month < 10) {
		month = '0' + month;
	}

	if (formate === 'yyyy-mm-dd') {
		return year + '-' + month + '-' + day;
	} else if (formate === 'dd/mm/yyyy') {
		return day + '/' + month + '/' + year;
	} else {
		if (time) {
			return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
		} else {
			return `${day}-${month}-${year}`;
		}
	}
}

export const pdfData = (data = [], header = [{}], text = 'list', width = 'a4') => {
	let _width = 210; // Width of the custom size
	const height = 297;
	if (width !== 'a4') {
		_width = width;
	}

	const doc = new jsPDF({
		orientation: 'landscape',
		unit: 'mm', // units: mm, cm, in, px
		format: [_width, height],
		compress: true,
		putOnlyUsedFonts: true,
		precision: 16, // n
	});
	const imgWidth = 25;
	const imgHeight = 9;
	const leftXPos = 14;
	const yPos = 2;
	doc.addImage(logo, 'PNG', leftXPos, yPos, imgWidth, imgHeight);
	const formattedDate = getCurrentDate();

	const textWidth = (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
	// Get the width of the PDF
	const pdfWidth = doc.internal.pageSize.width;
	const yPos1 = 10;
	// Calculate the X position for center alignment
	const centerXPos = (pdfWidth - textWidth) / 2;
	doc.text(text, centerXPos, yPos1);

	// Calculate the width of the date text
	const dateWidth = (doc.getStringUnitWidth(formattedDate) * doc.internal.getFontSize()) / doc.internal.scaleFactor;

	const rightXPos = pdfWidth - dateWidth - 15;
	doc.text(formattedDate, rightXPos, yPos1);

	// Create a table from API data

	if (!isEmpty(header)) {
		doc.autoTable({
			head: header,
			body: data,
		});
	} else {
		doc.autoTable({
			body: data,
		});
	}

	doc.save(`${text}.pdf`);
};

export const getLocation = () => {
	return new Promise((resolve, reject) => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					resolve(position.coords);
				},
				(error) => {
					reject(error);
				}
			);
		} else {
			reject(new Error('Geolocation is not supported by this browser.'));
		}
	});
};

export const sendNotification = (ref, type, text) => {
	if (ref.current) {
		ref.current.sendNotification(type, text);
	}
};

export function generateRandomString(length) {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	let result = '';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

export const isMobileDevice = () => {
	return /Mobi|Android|iPhone/i.test(navigator.userAgent);
  };



  export const CircleList = [
	{ label: "Select circle", value: "" },
	{ label: "Andhra Pradesh", value: "Andhra Pradesh" },
	{ label: "Assam", value: "Assam" },
	{ label: "Bihar", value: "Bihar" },
	{ label: "Chennai", value: "Chennai" },
	{ label: "Chhattisgarh", value: "Chhattisgarh" },
	{ label: "Gujarat", value: "Gujarat" },
	{ label: "Haryana", value: "Haryana" },
	{ label: "Himachal Pradesh", value: "Himachal Pradesh" },
	{ label: "Jammu And Kashmir", value: "Jammu And Kashmir" },
	{ label: "Karnataka", value: "Karnataka" },
	{ label: "Kerala", value: "Kerala" },
	{ label: "Kolkata", value: "Kolkata" },
	{ label: "Madhya Pradesh", value: "Madhya Pradesh" },
	{ label: "Maharashtra", value: "Maharashtra" },
	{ label: "NE1", value: "NE1" },
	{ label: "Odisha", value: "Odisha" },
	{ label: "Punjab", value: "Punjab" },
	{ label: "Rajasthan", value: "Rajasthan" },
	{ label: "Tamil Nadu", value: "Tamil Nadu" },
	{ label: "Uttar Pradesh East", value: "Uttar Pradesh East" },
	{ label: "Uttar Pradesh West", value: "Uttar Pradesh West" },
	{ label: "West Bengal", value: "West Bengal" }
  ]

  export function clickOutside(value,ref=null,setIsOpen=()=>{},type="small"){
	const handleClickOutside = (event) => {
	
		if ( !isEmpty(ref?.current) && !ref.current.contains(event.target)) {
			
		  setIsOpen();
		}
	  };
	
	
	  if(type === "small"){
		if((window.innerWidth >= 768)) return;
		if (!isEmpty(value)) {
			document.addEventListener("mousedown", handleClickOutside);
		  } else {
			document.removeEventListener("mousedown", handleClickOutside);
		  }
	  }else{
		if (!isEmpty(value)) {
			document.addEventListener("mousedown", handleClickOutside);
		  } else {
			document.removeEventListener("mousedown", handleClickOutside);
		  }
	  }
	 
  
  }




export function decryptData(encryptedText, secretKey) {
    
    let encryptedWordArray = CryptoJS.enc.Base64.parse(encryptedText);

 
    let decryptedBytes = CryptoJS.AES.decrypt(
        { ciphertext: encryptedWordArray },
        CryptoJS.enc.Utf8.parse(secretKey),
        { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    );


    let decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedText;
}



export function decryptData_(encryptedText,INIT_VECTOR, SECRET_KEY) {
    const key = CryptoJS.enc.Utf8.parse(generateMD5(SECRET_KEY));
    const iv = CryptoJS.enc.Utf8.parse(INIT_VECTOR);
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}


function generateMD5(secretKey) {
    try {
        return CryptoJS.MD5(secretKey).toString(CryptoJS.enc.Hex);
    } catch (error) {
        throw new Error(error.message);
    }
}

async function hashWithSHA256(secretKey) {
    const encoder = new TextEncoder();
    const data = encoder.encode(secretKey);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(byte => byte.toString(16).padStart(2, "0")).join("");
}